import { FormikProps } from "formik";

import { CheckboxMultiSelect } from "@/common/components/fields/checkbox-multi-select/CheckboxMultiSelect";
import { CourtFormType } from "@/pages/system-settings/tabs/courts/vienna/components/court-dialog/court-form-fields/CourtForm.types";
import { useTranslation } from "@/translations";

import { useAvailableDistricts } from "./hooks/useAvailableDistricts";

interface Props {
  formik: FormikProps<CourtFormType>;
  courtId?: string;
}

export function DistrictsMultiSelect({ formik, courtId }: Props) {
  const { t } = useTranslation();
  const { availableDistricts } = useAvailableDistricts(courtId);

  const districtsError = typeof formik.errors.districts === "string" ? formik.errors.districts : undefined;
  const showError = Boolean(formik.touched.districts) && districtsError !== undefined;

  const options = Array.from(new Set([...availableDistricts, ...formik.values.districts])).sort((a, b) => a - b);

  return (
    <CheckboxMultiSelect
      label={t("settings.courts.form.districts")}
      required
      options={options}
      value={formik.values.districts}
      onChange={(value) => void formik.setFieldValue("districts", value)}
      getOptionLabel={(code) => String(code)}
      getOptionKey={(code) => code}
      error={showError}
      helperText={showError ? districtsError : " "}
    />
  );
}
